import { useCallback } from 'react'

import { Cell, CellTypes } from '@inno-ui/table'
import { useTranslation } from 'react-i18next'

import { TableColumnIds } from '../constants'

export const useGetPropertyNameColumn = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'desktop' })

  return useCallback(
    (name: string) =>
      ({
        type: CellTypes.Text,
        columnId: TableColumnIds.Property,
        props: { value: t(name as never), bold: true }
      }) as Cell,
    [t]
  )
}
